export default [
  {
    path: '/ontime',
    component: () => import('src/layouts/DefaultLayout'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'OntimeVersionList',
        component: () => import('./containers/VersionListContainer'),
        children: [
          {
            path: 'create',
            name: 'OntimeVersionCreate',
            component: () => import('./containers/VersionCreateContainer'),
          },
          {
            path: ':versionId',
            name: 'OntimeVersionUpdate',
            props: true,
            component: () => import('./containers/VersionUpdateContainer'),
          },
        ],
      },
    ],
  },
]
